export const playerTypeOptions = [
  {
    key: 0,
    name: '球员'
  },
  {
    key: 1,
    name: '守门员'
  }
]
// 21年测试组  自行测试项目（运动能力测试项目 时间组
export const ageOptions = [
  {
    key: "2020/13",
    name: '2020年 13岁'
  },
  {
    key: "2020/14",
    name: '2020年 14岁'
  },
  {
    key: "2020/15",
    name: '2020年 15岁'
  },
  {
    key: "2020/16",
    name: '2020年 16岁'
  },
  {
    key: "2020/17",
    name: '2020年 17岁'
  },
  {
    key: "2020/18",
    name: '2020年 18岁'
  },
  {
    key: "2020/19",
    name: '2020年 19岁'
  },
  {
    key: "2020/20",
    name: '2020年 20岁'
  },
  {
    key: "2020/21",
    name: '2020年 21岁'
  },
  {
    key: "2020/22",
    name: '2020年 22岁'
  }
];
// 25年测试组  官方测试项目
export const ageOptionsGuanfang = [
  {
    key: "2025/10",
    name: '2025年 10岁'
  },
  {
    key: "2025/11",
    name: '2025年 11岁'
  },
  {
    key: "2025/12",
    name: '2025年 12岁'
  },
  {
    key: "2025/13",
    name: '2025年 13岁'
  },
  {
    key: "2025/14",
    name: '2025年 14岁'
  },
  {
    key: "2025/15",
    name: '2025年 15岁'
  },
  
]
// 21年测试组  官方测试项目
// export const ageOptionsGuanfang = [
//   {
//     key: "2021/13",
//     name: '2021年 13岁'
//   },
//   {
//     key: "2021/14",
//     name: '2021年 14岁'
//   },
//   {
//     key: "2021/15",
//     name: '2021年 15岁'
//   },
//   {
//     key: "2021/16",
//     name: '2021年 16岁'
//   },
// ];
// 自行测试项目（运动能力测试项目）
export const metricsOptions = [
  // {
  //   key: 'resultScore',
  //   name: '总分'
  // },
  // {
  //   name: '排名',
  //   key: 'ranking'
  // },
  // {
  //   name: '体脂',
  //   key: 'e4b4c4f470f4412cbffe55bd5a1cd597'
  // },
  {
    name: '臂展',
    key: '0029acb9119042c18b3ac7f8bbcb4716'
  },
  {
    name: '箭头跑',
    key: '9f9c14670b2541b78a80a0bb74a1f079'
  },
  {
    name: '30m跑',
    key: '9a14e8938b67429997e13765a221658d'
  },
  {
    name: '引体向上',
    key: 'e7ea9924bbb44a3383b2782cd4dbc478'
  },
  {
    name: '纵跳',
    key: '0bef00ce3cc6417790dfccc2c25bdcce'
  },
  {
    name: 'YOYO测试',
    key: 'a1867c0284ef4f7e99642c322a77f0dd'
  },
  {
    name: '体前屈',
    key: 'f219af266bb14f0eaa5cc2a366e11402'
  },
];
// 官方测试项目
export const metricsOptionsGuanfang = [
  // {
  //   key: 'resultScore',
  //   name: '总分'
  // },
  // {
  //   name: '排名',
  //   key: 'ranking'
  // },
  // {
  //   name: '体脂',
  //   key: 'e4b4c4f470f4412cbffe55bd5a1cd597'
  // },
  {
    name: '臂展',
    key: '0029acb9119042c18b3ac7f8bbcb4716'
  },
  {
    name: '左箭头跑',
    key: '1761adff3e6c4071b7965654820b40f0'
  },
  {
    name: '右箭头跑',
    key: '7da599bc85a6466da6f6b0fbc295b07b'
  },
  {
    name: '30m跑',
    key: '9a14e8938b67429997e13765a221658d'
  },
  {
    name: '引体向上',
    key: 'e7ea9924bbb44a3383b2782cd4dbc478'
  },
  {
    name: '纵跳',
    key: '0bef00ce3cc6417790dfccc2c25bdcce'
  },
  {
    name: 'YOYO测试',
    key: 'a1867c0284ef4f7e99642c322a77f0dd'
  },
  {
    name: '体前屈',
    key: 'f219af266bb14f0eaa5cc2a366e11402'
  },
];
// 22年测试组 自行测试项目（运动能力测试项目 时间组
export const ageOptions_2022 = [
  {
    key: '2022/5',
    name: '2022年 5岁',
  },
  {
    key: '2022/6',
    name: '2022年 6岁',
  },
  {
    key: '2022/7',
    name: '2022年 7岁',
  },
  {
    key: '2022/8',
    name: '2022年 8岁',
  },
  {
    key: '2022/9',
    name: '2022年 9岁',
  },
  {
    key: '2022/10',
    name: '2022年 10岁',
  },
  {
    key: '2022/11',
    name: '2022年 11岁',
  },
  {
    key: '2022/12',
    name: '2022年 12岁',
  },
  {
    key: "2022/13",
    name: '2022年 13岁'
  },
  {
    key: "2022/14",
    name: '2022年 14岁'
  },
  {
    key: "2022/15",
    name: '2022年 15岁'
  },
  {
    key: "2022/16",
    name: '2022年 16岁'
  },
  {
    key: "2022/17",
    name: '2022年 17岁'
  },
  {
    key: "2022/18",
    name: '2022年 18岁'
  },
  {
    key: "2022/19",
    name: '2022年 19岁'
  },
  {
    key: "2022/20",
    name: '2022年 20岁'
  },
  {
    key: "2022/21",
    name: '2022年 21岁'
  },
  {
    key: "2022/22",
    name: '2022年 22岁'
  }
];

// 22年测试组 自行测试项目（运动能力测试项目 时间组
export const yearOptionsALL = [
  {
    key: '2022',
    name: '2022年',
  },
  {
    key: '2023',
    name: '2023年',
  }
];

export const ageOptionsALL = [
  {
    key: '5',
    name: '5岁',
  },
  {
    key: '6',
    name: '6岁',
  },
  {
    key: '7',
    name: '7岁',
  },
  {
    key: '8',
    name: '8岁',
  },
  {
    key: '9',
    name: '9岁',
  },
  {
    key: '10',
    name: '10岁',
  },
  {
    key: '11',
    name: '11岁',
  },
  {
    key: '12',
    name: '12岁',
  },
  {
    key: "13",
    name: '13岁'
  },
  {
    key: "14",
    name: '14岁'
  },
  {
    key: "15",
    name: '15岁'
  },
  {
    key: "16",
    name: '16岁'
  },
  {
    key: "17",
    name: '17岁'
  },
  {
    key: "18",
    name: '18岁'
  },
  {
    key: "19",
    name: '19岁'
  },
  {
    key: "20",
    name: '20岁'
  },
  {
    key: "21",
    name: '21岁'
  },
  {
    key: "22",
    name: '22岁'
  }
];


// 22年测试组  自行测试项目（运动能力测试项目
export const metricsOptions_2022 = [
  {
    key: 'resultScore',
    name: '总分',
    valibleKey: [0, 1], // 0 球员；1 守门员
  },
  // {
  //   name: '排名',
  //   key: 'ranking',
  //   valibleKey: [0, 1],
  // },
  {
    name: '30米跑',
    key: '9a14e8938b67429997e13765a221658d',
    valibleKey: [0, 1],
  },
  {
    name: '立定跳远',
    key: 'ed5a2e59bf4b5bccb06afe719f3e36dc',
    valibleKey: [0, 1],
  },
  {
    name: '灵敏性测试',
    key: '511334284b1a51b583cd8234bcb7c5f3',
    valibleKey: [0, 1],
  },
  {
    name: '平衡球站立',
    key: '84ea1c769a3652f9a438550c41c59e6f',
    valibleKey: [0, 1],
  },
  {
    name: '带球跑',
    key: '142d290a17115867842b4b64d504a15c',
    valibleKey: [0, 1],
  },
  {
    name: '传控测试',
    key: '50daa04181835705a8be062b48143358',
    valibleKey: [0, 1],
  },
  {
    name: '臂展',
    key: '0029acb9119042c18b3ac7f8bbcb4716',
    valibleKey: [ 1],   // 守门员测试项
  },
  
//     （守门员）
//       （守门员）
  {
    name: '单臂手抛球',
    key: 'a1bd864598da5741a437efb6d14f2ac1',
    valibleKey: [ 1],
  },
  {
    name: '定点踢远',
    key: '32fd74cced9a5bf69e7d3d75f94c1a06',
    valibleKey: [ 1],
  },
]

export const pagesizeOptions = [
  {
    key: 10,
    name: '10条'
  },
  {
    key: 20,
    name: '20条'
  },
  {
    key: 30,
    name: '30条'
  },
  {
    key: 40,
    name: '40条'
  },
  {
    key: 50,
    name: '50条'
  },
];

export function getMetricsName(key) {
  let metricsName = null;
  metricsOptions.some(item => {
    if(key === item.key) {
      metricsName = item.name;
      return true
    }
  })
  if(metricsName) {
    return metricsName
  } else {
    return 'error_name'
  }
};
// 通用获取名字
export function getMetricsNameForDefault(key='', list=[]) {
  if(!list.length) return 'list_error'
  let metricsName = null;
  list.some(item => {
    if(key === item.key) {
      metricsName = item.name;
      return true
    }
  })
  if(metricsName) {
    return metricsName
  } else {
    return 'error_name'
  }
}

export function getMetricsNameGuanfang(key) {
  let metricsName = null;
  metricsOptionsGuanfang.some(item => {
    if(key === item.key) {
      metricsName = item.name;
      return true
    }
  })
  if(metricsName) {
    return metricsName
  } else {
    return false
  }
};
